import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "datatable" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "left row-vcenter" }
const _hoisted_4 = { class: "right row-vcenter" }
const _hoisted_5 = {
  key: 0,
  class: "empty"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_DataTable = _resolveComponent("DataTable")
  const _directive_resize = _resolveDirective("resize")

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["datatable-relative scrollable", {scrolled: $data.scrolled}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "header-left", {}, undefined, true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "header-right", {}, undefined, true)
        ])
      ]),
      (!$props.items.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "empty", {}, undefined, true)
          ]))
        : (_openBlock(), _createBlock(_component_DataTable, {
            key: 1,
            value: $props.items,
            scrollable: "",
            "scroll-height": $props.scrollHeight,
            pt: {
                   root: 'root',
                   table: 'table shared-table',
                   tableContainer: {class: 'table-container', onScroll: $options.updateScroll},
                   thead: 'thead',
                   tbody: 'tbody',
                   headerRow: 'headerRow',
                   bodyRow: 'bodyRow',
                   column: {
                     headerCell: 'headerCell',
                     bodyCell: 'bodyCell',
                     columnHeaderContent: 'columnHeaderContent'
                   }
                 }
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default", {}, undefined, true)
            ]),
            _: 3 /* FORWARDED */
          }, 8 /* PROPS */, ["value", "scroll-height", "pt"]))
    ])
  ], 2 /* CLASS */)), [
    [_directive_resize, $options.updateScroll]
  ])
}